import React from "react";
import ManageScholarship from "../ManageScholarship";
import Modal from "../../../../elements/Modal";

const ManageScholarshipModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl4" title={data?._id?"Update Scholarship":"Create New "}>
      <ManageScholarship getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageScholarshipModal;
